// src/components/SISSidebar.js
import React from "react";
import { NavLink } from "react-router-dom";

const SIDEBAR_WIDTH = 260;

const navItemStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "12px 18px",
  borderRadius: 8,
  color: "#333",
  textDecoration: "none",
  fontWeight: 600,
};

export default function SISSidebar() {
  const storedUser = (() => { try { return JSON.parse(localStorage.getItem("user") || "{}"); } catch { return {}; } })();
  const primary = String(storedUser?.role || "").toLowerCase();
  const extras = Array.isArray(storedUser?.roles) ? storedUser.roles.map(r => String(r).toLowerCase()) : [];
  const roles = [primary, ...extras].filter(Boolean);
  const encoderOnly = roles.includes("encoder") && !roles.some(r => ["admin", "superadmin", "registrar", "finance"].includes(r));
  return (
    <aside className="sis-sidebar" style={{ width: SIDEBAR_WIDTH, background: "#ffb300", minHeight: "100vh", padding: 18 }}>
      <div style={{ textAlign: "center", marginBottom: 18 }}>
        <img
          src="/vmsc_logo.png"
          alt="logo"
          style={{ width: 84, height: 84, borderRadius: "50%", objectFit: "cover", border: "2px solid #ff9800" }}
        />
      </div>

      <nav>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {!encoderOnly && (
            <li style={{ marginBottom: 6 }}>
              <NavLink
                to="/sis/dashboard"
                className="nav-link"
                style={({ isActive }) => ({
                  ...navItemStyle,
                  background: isActive ? "#fff" : "transparent",
                  boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                  color: "#333",
                  borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
                })}
              >
                <i className="bi bi-speedometer2" style={{ fontSize: 18 }}></i>
                Dashboard
              </NavLink>
            </li>
          )}

          <li style={{ marginBottom: 6 }}>
            <NavLink
              to="/sis/students"
              style={({ isActive }) => ({
                ...navItemStyle,
                background: isActive ? "#fff" : "transparent",
                boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
              })}
            >
              <i className="bi bi-people" style={{ fontSize: 18 }}></i>
              Students
            </NavLink>
          </li>

          <li style={{ marginBottom: 6 }}>
            <NavLink
              to="/sis/enrollment"
              style={({ isActive }) => ({
                ...navItemStyle,
                background: isActive ? "#fff" : "transparent",
                boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
              })}
            >
              <i className="bi bi-journal-bookmark" style={{ fontSize: 18 }}></i>
              Enrollment
            </NavLink>
          </li>

          {!encoderOnly && (
            <li style={{ marginBottom: 6 }}>
              <NavLink
                to="/sis/subjects"
                style={({ isActive }) => ({
                  ...navItemStyle,
                  background: isActive ? "#fff" : "transparent",
                  boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                  borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
                })}
              >
                <i className="bi bi-book" style={{ fontSize: 18 }}></i>
                Subjects
              </NavLink>
            </li>
          )}

          {!encoderOnly && (
            <li style={{ marginBottom: 6 }}>
              <NavLink
                to="/sis/finance"
                style={({ isActive }) => ({
                  ...navItemStyle,
                  background: isActive ? "#fff" : "transparent",
                  boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                  borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
                })}
              >
                <i className="bi bi-cash-stack" style={{ fontSize: 18 }}></i>
                Finance
              </NavLink>
            </li>
          )}

          {/* Switch System Section */}
          {!encoderOnly && (
            <>
              <li style={{ marginTop: 24 }}>
                <div style={{ padding: "0 18px", marginBottom: 12 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, opacity: 0.8, color: "#5d4037" }}>
                    Switch System
                  </div>
                </div>
              </li>
              <li style={{ marginBottom: 6 }}>
                <NavLink
                  to="/finance/dashboard"
                  style={({ isActive }) => ({
                    ...navItemStyle,
                    background: isActive ? "#fff" : "transparent",
                    boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                    borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
                  })}
                >
                  <i className="bi bi-cash" style={{ fontSize: 18 }}></i>
                  Finance System
                </NavLink>
              </li>
              <li style={{ marginBottom: 6 }}>
                <NavLink
                  to="/hr/payroll"
                  style={({ isActive }) => ({
                    ...navItemStyle,
                    background: isActive ? "#fff" : "transparent",
                    boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                    borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
                  })}
                >
                  <i className="bi bi-people" style={{ fontSize: 18 }}></i>
                  HR / Payroll System
                </NavLink>
              </li>
            </>
          )}
        </ul>
      </nav>
    </aside>
  );
}
